/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {FormikValues} from 'formik'
import MuiPhoneNumber from 'material-ui-phone-number'

const AddTenantStep2 = ({formik}: FormikValues) => {
  return (
    <div data-kt-stepper-element='content'>
      <div className='w-100'>
        {/*begin::Form Group Business Name */}
        <div className='fv-row mb-6'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Business Name</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter business name'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            name='business_name'
            placeholder='Enter business name'
            {...formik.getFieldProps('business_name')}
          />
          <div className='h-20px'>
            {formik.touched.business_name && formik.errors.business_name && (
              <div className='fv-help-block color-red'>{formik.errors.business_name}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Business Name */}
        {/*begin::Form Group Business Email*/}
        <div className='fv-row mb-6'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Business Email</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter business email'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            name='business_email_id'
            placeholder='Enter business email'
            {...formik.getFieldProps('business_email_id')}
          />
          <div className='h-20px'>
            {formik.touched.business_email_id && formik.errors.business_email_id && (
              <div className='fv-help-block color-red'>{formik.errors.business_email_id}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Business Email*/}
        {/*begin::Form Group Business Contact Number*/}
        <div className='fv-row mb-6'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Business Contact Number</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter business contact number'
            ></i>
          </label>
          <MuiPhoneNumber
            {...formik.getFieldProps('business_contact_number')}
            className='w-100'
            defaultCountry={'in'}
            onChange={(value: string) => formik.setFieldValue('business_contact_number', value)}
          />
          <div className='h-20px'>
            {formik.touched.business_contact_number && formik.errors.business_contact_number && (
              <div className='fv-help-block color-red'>{formik.errors.business_contact_number}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Business Contact Number*/}
      </div>
    </div>
  )
}

export default AddTenantStep2
